/* eslint-disable no-prototype-builtins */
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import { Link } from 'react-router-dom'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import AddIcon from '@mui/icons-material/Add'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import ReplayIcon from '@mui/icons-material/Replay'
import RefreshIcon from '@mui/icons-material/Refresh'

import { aboutMeJSX } from './helpers/aboutMeJSX'
import { hobbiesJSX } from './helpers/hobbiesJSX'
import { promptsJSX } from './helpers/promptsJSX'
import { vitalInfoJSX } from '../bio/helpers/vitalInfoJSX'
import { statsJSX } from './helpers/statsJSX'
import { rateAndVisibilityJSX } from './helpers/rateAndVisibilityJSX'

import { fullReviewerProfileModalJSX } from '../../requestFeedback/helpers/modals/fullReviewerProfileModalJSX'
import { requiredVitalInfoExists } from '../../../helpers/commonMethods'

import useWindowDimensions from '../../../helpers/windowDimensions'
import { standardButton, standardButtonWithObjectAndIndex, addImageWithTextButton, replaceImageWithIconButton, exitModalIconButton } from '../../../helpers/buttons'
import { standardSpinner } from '../../../helpers/spinners'
import { getPayload, getTokenFromLocalStorage, userIsAuthenticated, getEmailFromLocalStorage, setIsReviewerToLocalStorage } from '../../../helpers/storage'
import { agesArray, positionChangeWidthSm, positionChangeWidthMd, swipelyticsPink, swipelyticsTurquoise, navbarHeight, footerHeight, dashboardNavbarHeight, profPicDefaultURL } from '../../../helpers/variableDefaults'
import { selectSortCategory } from '../../../helpers/selects'
import { couldNotLoadPageError } from '../../../helpers/errors'
import { switchWithTitle } from '../../../helpers/switches'
import { modifyInDatabase } from '../../../helpers/modifyInDatabase'
import { seoPageTags, customAnalyticsEvent } from '../../../helpers/analytics'
import { searchTextField } from '../../../helpers/textfields'
import { standardPagination } from '../../../helpers/pagination'
import { reloadView, numberWithCommas } from '../../../helpers/globalHelpers'
import { handleImageSelectProfilePicture } from '../../../helpers/profilePictureElements'
import { standardErrorContainer } from '../../../helpers/errors'
import { saveSuccessfulTypography } from '../../../helpers/typographies'

import { Input } from '../../../helpers/globalHelpers'

// Reviewer Bio Page
const ReviewerBio = () => {
  
  // Window Dimensions
  const { height, width } = useWindowDimensions()
  
  // Navigate
  const navigate = useNavigate()

  // Params
  const { userId } = useParams()

  // Payload
  const payload = getPayload()

  // User
  const [user, setUser] = useState({})

  // Rate and Visibility
  const [newRateAndVisibility, setNewRateAndVisibility] = useState({
    reviewRate: 30,
    isVisible: true,
  })
  
  // View Reviewer Profile
  const [openFullReviewerProfileModal, setOpenFullReviewerProfileModal] = useState(false)
  const [reviewerProfileToView, setReviewerProfileToView] = useState({})
  // Bio
  const [bioObject, setBioObject] = useState({
    aboutMe: [''], // Array of 'About Me' section strings
    prompts: [
      {
        prompt: '',
        response: '',
      },
      {
        prompt: '',
        response: '',
      },
      {
        prompt: '',
        response: '',
      }
    ], // Array of 'Prompt' objects; each Object has the keys: 'prompt' and 'response' 
    hobbies: ['', '', '', '', ''], // Array of 'hobbies' strings; 
    vitalInfo: {
      firstName: '', 
      age: -1,
      gender: '',
      sexuality: '',
      pronouns: '',
      interestedIn: '',
      interestedInAgeMin: agesArray[0],
      interestedInAgeMax: agesArray[agesArray.length - 1],
      heightInches: -1,
      heightCM: -1,
      inOrCmPreference: 'in',
      currentCity: '',
      hometown: '',
      languages: [],
      religion: [],
      politics: '',
      educationLevel: '',
      university: '',
      profession: '',
      employer: ``,
      children: '',
      familyPlans: '',
      datingIntentions: '',
      relationshipType: '',
      ethnicity: '',
      alcohol: '',
      cigarettes: '',
      weed: '',
      drugs: '',
      pets: [],
      zodiac: '',
      hidden: [],
    },
  })
  const [newAboutMe, setNewAboutMe] = useState([''])
  const [newPrompts, setNewPrompts] = useState([
    {
      prompt: '',
      response: '',
    },
    {
      prompt: '',
      response: '',
    },
    {
      prompt: '',
      response: '',
    }
  ])
  const [newHobbies, setNewHobbies] = useState(['', '', '', '', ''])
  const [newVitalInfo, setNewVitalInfo] = useState({
    firstName: '', 
    age: -1,
    gender: '',
    sexuality: '',
    pronouns: '',
    interestedIn: '',
    interestedInAgeMin: agesArray[0],
    interestedInAgeMax: agesArray[agesArray.length - 1],
    heightInches: -1,
    heightCM: -1,
    inOrCmPreference: 'in',
    currentCity: '',
    hometown: '',
    languages: [],
    religion: [],
    politics: '',
    educationLevel: '',
    university: '',
    profession: '',
    employer: ``,
    children: '',
    familyPlans: '',
    datingIntentions: '',
    relationshipType: '',
    ethnicity: '',
    alcohol: '',
    cigarettes: '',
    weed: '',
    drugs: '',
    pets: [],
    zodiac: '',
    hidden: [],
  })

  // Profile Picture
  const [previousImage, setPreviousImage] = useState('') //For Deleting Previous Profile Picture

  // Loading
  const [loading, setLoading] = useState(false)
  const [loadingAboutMe, setLoadingAboutMe] = useState(false)
  const [loadingPrompts, setLoadingPrompts] = useState(false)
  const [loadingHobbies, setLoadingHobbies] = useState(false)
  const [loadingVitalInfo, setLoadingVitalInfo] = useState(false)
  const [loadingProfPic, setLoadingProfPic] = useState(false)
  const [loadingRateAndVisibility, setLoadingRateAndVisibility] = useState(false)

  // Save Successful
  const [saveSuccessful, setSaveSuccessful] = useState({
    aboutMe: false,
    prompts: false,
    hobbies: false,
    vitalInfo: false,
    profilePicture: false,
    rateAndVisibility: false,
  })

  // Errors
  const [errors, setErrors] = useState(false)
  const [bioErrors, setBioErrors] = useState({
    aboutMe: false,
    prompts: false,
    hobbies: false,
    vitalInfo: false,
    rateAndVisibility: false,
  })
  const [uploadProfilePictureErrors, setUploadProfilePictureErrors] = useState(false)


  const resetErrors = () => {
    setErrors(false)
    setUploadProfilePictureErrors(false)
    setBioErrors({
      aboutMe: false,
      prompts: false,
      hobbies: false,
      vitalInfo: false,
    })
  }

  const resetLoading = () => {
    setLoading(false)
    setLoadingAboutMe(false)
    setLoadingPrompts(false)
    setLoadingHobbies(false)
    setLoadingVitalInfo(false)
    setLoadingProfPic(false)
  }

  const resetSaveSuccessful = () => {
    setSaveSuccessful({
      aboutMe: false,
      prompts: false,
      hobbies: false,
      vitalInfo: false,
      profilePicture: false,
    })
  }

  // UseEffect — Send to user their own dashboard if payload doesn't match userId
  useEffect(() => {

    if (!userIsAuthenticated()) {
      navigate('/login')
    } else if (userId !== payload.sub) {
      navigate(`/dashboard/${payload.sub}`)
      // reloadView()
    } else {
      const getData = async () => {
        setLoading(true)
        try {
          const { data: retrievedUser } = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/users/${payload.sub}`, {
            headers: {
              Authorization: `Bearer ${getTokenFromLocalStorage()}`,
            },
          })
          // console.log('retrieved User ->', retrievedUser)
          if (!retrievedUser.isReviewer) {
            setIsReviewerToLocalStorage(false)
            reloadView()
          } else if (payload.sub === retrievedUser._id) {
            // Set States
            setUser(retrievedUser)
            setBioObject(retrievedUser.hasOwnProperty('bio') && retrievedUser.bio !== null ? { ...retrievedUser.bio } : bioObject)
            setNewAboutMe(retrievedUser.hasOwnProperty('bio') && retrievedUser.bio !== null && 'aboutMe' in retrievedUser.bio && retrievedUser.bio.aboutMe.length > 0 ? [ ...retrievedUser.bio.aboutMe] : newAboutMe)
            setNewPrompts(retrievedUser.hasOwnProperty('bio') && retrievedUser.bio !== null && 'prompts' in retrievedUser.bio && retrievedUser.bio.prompts.length > 0 ? [ ...retrievedUser.bio.prompts ] : newPrompts)
            setNewHobbies(retrievedUser.hasOwnProperty('bio') && retrievedUser.bio !== null && 'hobbies' in retrievedUser.bio && retrievedUser.bio.hobbies.length > 0 ? [ ...retrievedUser.bio.hobbies] : newHobbies)
            setNewVitalInfo(retrievedUser.hasOwnProperty('bio') && retrievedUser.bio !== null && 'vitalInfo' in retrievedUser.bio && Object.keys(retrievedUser.bio.vitalInfo).length > 0 ? { ...newVitalInfo, ...retrievedUser.bio.vitalInfo } : newVitalInfo)

            setPreviousImage(
              retrievedUser.hasOwnProperty('reviewerProfile') 
              && 'profilePicture' in retrievedUser.reviewerProfile 
              && retrievedUser.reviewerProfile.profilePicture !== null
              && retrievedUser.reviewerProfile.profilePicture.length > 0
                ? 
                retrievedUser.reviewerProfile.profilePicture
                : 
                profPicDefaultURL
            )
            if (
              retrievedUser.hasOwnProperty('reviewerProfile')
            ) {
              setNewRateAndVisibility({
                reviewRate: retrievedUser.reviewerProfile.reviewRate,
                isVisible: retrievedUser.reviewerProfile.isVisible,
              })
            }
            
            setErrors(false)
            setLoading(false)
          } else {
            navigate(`/`)
            setErrors(false)
            setLoading(false)
          }

        } catch (error) {
          // console.log(error)

          navigate(`/`)

          setErrors(true)
          setLoading(false)
        }
      }

      getData()
    }

  }, [])

  useEffect(() => {
    // console.log('useEffect Runs')
    // console.log('newRateAndVisibility ->', newRateAndVisibility)
    // console.log('previous prof pic ->', previousImage)
    // console.log('current prof pic ->', user.hasOwnProperty('reviewerProfile') ? user.reviewerProfile.profilePicture : 'no user')

  }, [newAboutMe, newPrompts, newHobbies, newVitalInfo, user, newRateAndVisibility, saveSuccessful, bioErrors, openFullReviewerProfileModal, reviewerProfileToView])


  const handleViewFullReviewerProfilePressed = (e) => {
    e.preventDefault()
    // console.log('handleViewFullReviewerProfilePressed runs')
    // console.log('reviewerProfileObj ->', reviewerProfileObj)
    const newBio = {
      aboutMe: newAboutMe,
      hobbies: newHobbies,
      prompts: newPrompts,
      vitalInfo: newVitalInfo,
    }

    const reviewerProfileObj = {
      ...user.reviewerProfile,
      bio: newBio,
    }
    setReviewerProfileToView(reviewerProfileObj)
    setOpenFullReviewerProfileModal(true)
  }

  const uploadModifiedProfilePicture = async (modifiedPropertiesObj) => {

    resetSaveSuccessful()

    try {

      // PUT request with updated profile object
      // await axios.put(`/api/users/${userId}`, newForm, {
      await axios.put(`${process.env.REACT_APP_SERVER_URL}/api/reviewer-profiles/${user.reviewerProfile._id}`, modifiedPropertiesObj, {
        headers: {
          Authorization: `Bearer ${getTokenFromLocalStorage()}`,
        },
      })

      // console.log('new-prof-pic ->', modifiedPropertiesObj.profilePicture)

      const newReviewerProfile = { ...user.reviewerProfile, profilePicture: modifiedPropertiesObj.profilePicture }
      // console.log('newReviewerProfile ->', newReviewerProfile)

      setUser({ ...user, reviewerProfile: newReviewerProfile })
      
      setSaveSuccessful({ ...saveSuccessful, profilePicture: true })
    } catch (error) {
      // console.log(error)

      // error message posting new profile
      resetLoading()

      setUploadProfilePictureErrors(true)
      
    }
  }

  return (
    <>
      {/* Helmet — for analytics, seo, and page title changing */}
      {seoPageTags(
        'Reviewer Bio'
      )}

      {/* Body */}
      {loading ?
        <Box sx={{ 
          width: '100%',
          // minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight} - ${dashboardNavbarHeight})`,
          minHeight: `calc(100vh - ${navbarHeight} - ${dashboardNavbarHeight})`,
          mt: 0, mb: 0,
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', 
        }}>
          {standardSpinner()}
        </Box>
        :
        errors ? 
          <Box
            sx={{
              // backgroundColor: 'yellow',
              width: '100%',
              minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight} - ${dashboardNavbarHeight})`,
              display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', 
            }}
          >
            {couldNotLoadPageError()}
          </Box>
          :
          <Box
            sx={{
              // backgroundColor: 'green',
              pt: 4, pb: 4,
              width: '100%',
              minHeight: `calc(100vh - ${navbarHeight} - ${footerHeight} - ${dashboardNavbarHeight})`,
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
            }}
          > 
            {/* Inactive Subscription */}
            {user.hasOwnProperty('subscriptionIsActive') && !user.subscriptionIsActive &&
              <Box
                sx={{
                  backgroundColor: 'red',
                  color: 'white',
                  py: 3, px: 3,
                  width: '100%', 
                  // height: '100px',
                  fontSize: '18px', fontWeight: 'bold',
                  display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
                }}
              >
                {`Click 'Manage Subscription' in the 'Settings' tab to reactivate subscription`}
              </Box>
            }

            {/* This must be first input So that the file upload only fires when you press the button */}
            <Box sx={{ width: '100%' }}>
              <Input type="text" autoFocus="autoFocus" />
            </Box>

            {/* Profile Picture */}
            {replaceImageWithIconButton(
              user.hasOwnProperty('reviewerProfile') && 'profilePicture' in user.reviewerProfile && user.reviewerProfile.profilePicture !== null && user.reviewerProfile.profilePicture.length > 0 ? user.reviewerProfile.profilePicture : profPicDefaultURL, 
              previousImage,
              setPreviousImage,
              width > 399 ? 200 : width > 299 ? 200 : 175, 
              'icon-button-file', 
              'replace-prof-pic', 
              handleImageSelectProfilePicture,
              -3,
              loadingProfPic, 
              setLoadingProfPic, 
              resetErrors, 
              user._id, 
              uploadModifiedProfilePicture, 
              user, 
              setUser, 
              'profilePicture', 
              setUploadProfilePictureErrors,
              'expert'
            )}

            {/* Error Message, if errors */}
            {uploadProfilePictureErrors &&
              standardErrorContainer(
                'Error uploading image. Please try again.',
                0,
                0
              )
            }

            {/* Save Successful */}
            {saveSuccessful.profilePicture &&
              saveSuccessfulTypography(0, 2)
            }

            {/* Rate and Visibility */}
            {'reviewerProfile' in user
              && 'isCoach' in user.reviewerProfile
              &&
              rateAndVisibilityJSX(
                user, setUser,
                newRateAndVisibility, setNewRateAndVisibility,
                loadingRateAndVisibility, setLoadingRateAndVisibility,
                saveSuccessful, setSaveSuccessful, resetSaveSuccessful,
                bioErrors, setBioErrors,
                width
              )
            }

            
            {/* About Me */}
            {aboutMeJSX(
              bioObject, setBioObject,
              newAboutMe, setNewAboutMe,
              loadingAboutMe, setLoadingAboutMe,
              saveSuccessful, setSaveSuccessful, resetSaveSuccessful,
              bioErrors, setBioErrors,
              width
            )}

            {/* Hobbies */}
            {hobbiesJSX(
              bioObject, setBioObject,
              newHobbies, setNewHobbies,
              loadingHobbies, setLoadingHobbies,
              saveSuccessful, setSaveSuccessful, resetSaveSuccessful,
              bioErrors, setBioErrors,
              width
            )}
            
            {/* Prompts */}
            {promptsJSX(
              bioObject, setBioObject,
              newPrompts, setNewPrompts,
              loadingPrompts, setLoadingPrompts,
              saveSuccessful, setSaveSuccessful,
              bioErrors, setBioErrors,
              width
            )}
            
            {/* Vital Info */}
            {vitalInfoJSX(
              'reviewerBio',
              bioObject, setBioObject,
              newVitalInfo, setNewVitalInfo,
              loadingVitalInfo, setLoadingVitalInfo,
              saveSuccessful, setSaveSuccessful, 
              // resetSaveSuccessful,
              bioErrors, setBioErrors,
              width,
              false
            )}

            {/* Stats */}
            {user.hasOwnProperty('reviewerProfile') 
              // && 'profileReviews' in user.reviewerProfile
              // && user.reviewerProfile.profileReviews !== null
              && 
              <Box
                sx={{
                  py: 3, my: 2, 
                  // px: 2,
                  width: '90%',
                  maxWidth: '600px',
                  backgroundColor: 'whitesmoke',
                  borderRadius: 3, boxShadow: 3,
                  display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
                }}
              >
                <Box
                  sx={{
                    width: '90%',
                    display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
                  }}
                >
                  {statsJSX(
                    user.reviewerProfile,
                    width
                  )}
                </Box>
              </Box>
            }

            {/* View Reviewer Profile */}
            {
              'bio' in user
              && 'vitalInfo' in user.bio
              // && requiredVitalInfoExists(user.bio.vitalInfo) 
              && 'reviewerProfile' in user
              && 
              <Box
                sx={{
                  py: 3, my: 2, 
                  // px: 2,
                  width: '90%',
                  maxWidth: '600px',
                  backgroundColor: 'whitesmoke',
                  borderRadius: 3, boxShadow: 3,
                  display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
                }}
              >
                <Box
                  sx={{
                    width: '90%',
                    display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
                  }}
                >
                  {standardButtonWithObjectAndIndex(
                    'View Profile', 
                    'button',
                    'contained',
                    false,
                    'primary', 
                    0,
                    0,
                    0,
                    width > 300 ? '220px' : '95%', 
                    '45px', 
                    handleViewFullReviewerProfilePressed,
                    'reviewerProfile' in user ? user.reviewerProfile : {},
                    0
                  )}
                </Box>
              </Box>
            }

            {/* Feedback Info Modal */}
            {openFullReviewerProfileModal && reviewerProfileToView !== null && Object.keys(reviewerProfileToView).length > 0 &&
              fullReviewerProfileModalJSX(false, {}, 'hinge', reviewerProfileToView, setReviewerProfileToView, openFullReviewerProfileModal, setOpenFullReviewerProfileModal, width)
            }


          </Box>
      }
    </>
  )
}

export default ReviewerBio